import { Serializable } from "@/core/api/decorators/serializable_decorator"

@Serializable
export class ApproverCostModel {
  cost: number = 0
  numApprovers: number = 0
  durationWeeks: number = 0
  isHourlyRateApproverRequired: boolean = false
  hourlyRateApproverLevel: number = 0
  exceedsHalfYearPolicy: boolean = false
  exceedsYearPolicy: boolean = false

  constructor(
    data: {
      cost: number
      numApprovers: number
      durationWeeks: number
      isHourlyRateApproverRequired: boolean
      hourlyRateApproverLevel: number
      exceedsHalfYearPolicy: boolean
      exceedsYearPolicy: boolean
    } | null = null,
  ) {
    if (data) {
      this.cost = data.cost
      this.numApprovers = data.numApprovers
      this.durationWeeks = data.durationWeeks ?? 0
      this.isHourlyRateApproverRequired =
        data.isHourlyRateApproverRequired ?? false
      this.hourlyRateApproverLevel = data.hourlyRateApproverLevel ?? 0
      this.exceedsHalfYearPolicy = data.exceedsHalfYearPolicy ?? false
      this.exceedsYearPolicy = data.exceedsYearPolicy ?? false
    }
  }
}
